export var PartnershipLevel;
(function (PartnershipLevel) {
    PartnershipLevel["Bronze"] = "bronze";
    PartnershipLevel["Silver"] = "silver";
    PartnershipLevel["Gold"] = "gold";
    PartnershipLevel["Platinum"] = "platinum";
})(PartnershipLevel || (PartnershipLevel = {}));
